module.exports = __webpack_public_path__ + "static/media/sholder_detail.1158cd60.png";